import { createInjectionKey as n } from "./ghl-ui.es920.js";
const o = n("n-menu"), t = n("n-submenu"), m = n("n-menu-item-group");
export {
  o as menuInjectionKey,
  m as menuItemGroupInjectionKey,
  t as submenuInjectionKey
};
